import { createRestSlice } from "./restSlice";

export type OrganizationMember = {
  id: string;
  organizationId: string;
  userId: string;
  role: string;
  name: string;
  email: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationMembersSlice = createRestSlice<OrganizationMember>("organizationMembers", "/v1/organizations/:organizationId/members");

export const organizationMembersReducer = organizationMembersSlice.reducer;
export const organizationMembersActions = organizationMembersSlice.actions;
